import React from 'react';
import { jsPDF } from 'jspdf';
import "jspdf-autotable"
import autoTable from "jspdf-autotable";

export const PlantillaOrdenCompra = (proveedor,fechaEmision,fechaEntrega,numeroOrden,nombrecompania,direccion,telefono,dataresultados) => {

    const doc = new jsPDF();

    // Añadir contenido al PDF
    doc.setFontSize(16);
    //doc.text(nombrecompania, 10, 10);
    //doc.setFontSize(12);
    //doc.text(direccion, 10, 15);
  //  doc.text(telefono, 10, 20);
//    doc.text('Registro de Compras', 10, 25);

    let x = 10
    let y = 30
    
    //doc.setDrawColor(0,0,255)
    //doc.rect(10,30,90,20,"S")  //primer cuadro
    //doc.rect(110,30,90,20,"S") //segundo cuadro 
    
    // Tabla de información del proveedor
    alert(JSON.stringify(proveedor))
    const proveedorHeaders = [["Información del Proveedor",""]];
    const proveedorData = [
        ["Proveedor:", proveedor.label],
        ["Teléfono:", proveedor.telefono],
        ["RNC:", proveedor.rnc],
        ["Fecha de emision:", fechaEmision],
        ["Fecha de entrega:", fechaEntrega],

    ];

    // Generar tabla del proveedor
    autoTable(doc, {
        head: proveedorHeaders,
        body: proveedorData,
        startY: 32,
        startX: 12,
        tableWidth: 100,
        bodyStyles: {
            fontSize: 10,   
            cellPadding: 3,
        },
        columnStyles: {
            0: { cellWidth: 50, fontStyle: 'bold'},
            1: { cellWidth: 40 }
        }
    });

    /////2da. tabla
    doc.setFontSize(17)
    doc.setFont("helvetica", "bold");
    doc.text(nombrecompania,90-nombrecompania.length,15)

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10)
    doc.text('Orden de Compra',170,20)
    doc.setFontSize(12)
    doc.setFont("helvetica", "bold");
    doc.text('No.'+numeroOrden.toString(),170,24)
 
    

    
    //header
    const encabezados = [["Item","Descripcion","Cantidad","Precio","Itbis","Total"]] 
    
    
//    const data1 = JSON.stringify(dataresultados)
//    const data2 = JSON.parse(data1)
 
    
  
    // Configuración de la tabla
    const rows = [];
    dataresultados.forEach((item) => { 
      // Fila principal
      rows.push([item.nombre ,item.descripcion_producto, item.cantidad, item.precio_unitario, item.impuestos,item.subtotal]);
    
      // Subfilas
      
    });

    // Transformar los datos para el AutoTable


    // Generar la tabla
    autoTable(doc, {
      head: encabezados,
      body: rows,//[rows],
      startY: 103, // Posición inicial

//      didParseCell: function (data) {
        
  //      if (data.row.index > 0) {
  //        if (data.row.index % 2 !== 0) {
  //          data.cell.styles.fontStyle = 'bold';
  //        } else {
            //data.cell.styles.fillColor = [245, 245, 245];
  //        }
  //      }
  //    }
      
    });
    

    const ultimaposicionY = doc.lastAutoTable.finalY
    var totalvalue = 0.0
    
    //cacular totales
    //cacular totales
    const totalsubtotal = dataresultados.reduce((sum,row) => sum + (parseFloat(row.subtotal)),0)
    const totalitbis = dataresultados.reduce((sum,row) => sum + (parseFloat(row.impuestos)),0)
    const totaldescuento = dataresultados.reduce((sum,row) => sum + (parseFloat(row.descuento)),0)
    
    //totales 
    var posY = 0
    posY = ultimaposicionY
    posY = posY + 15
    doc.text("Subtotal",125,posY)
    doc.text(totalsubtotal.toFixed(2).toString(),175,posY,{align: 'right'})
  

    posY = posY + 5
    doc.text("Itbis",125,posY)
    doc.text(totalitbis.toFixed(2).toString(),175,posY,{align: 'right'})

    posY = posY + 5
    doc.text("Total",125,posY)
    doc.text((totalsubtotal+totalitbis).toFixed(2).toString(),175,posY,{align: 'right'})

    
//    if (dataresultados[0]['notacierre'].length != 0){
  //    posY = posY + 15
    //  posY = posY + 5
   //   doc.text("Nota de Cierre",20,posY)
   //   posY = posY + 5
     // doc.text(dataresultados[0]['notacierre'],20,posY,{align: 'left'})
  
 //   }
    


    // Abrir el PDF en una nueva pestaña
    const pdfBlob = doc.output('blob');
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl, '_blank');
};


